import { IconSearch as FigmaIconSearch } from '@redteclab/icons'
import { type FC } from 'react'

import SvgIcon, { type IconProps } from './SvgIcon'

const IconSearch: FC<IconProps> = props => (
  <SvgIcon {...props} component={FigmaIconSearch} />
)

export default IconSearch
